const publickey = process.env.REACT_APP_PUBLIC_KEY

export default publickey;